export const BROADCAST_CHANNELS = {
  AUTHENTICATION: 'authentication'
} as const;
